module.exports = __webpack_public_path__ + "static/media/facebook-green.af53a9fe.png";